<template lang="pug">
  .leaderboard
    .page__content
      .leaderboard__header
        h1 {{ $t('leaderboardTitle') }}:
        .leaderboard__header-tabs
          .leaderboard__header-tab(v-t="'weeklyLeaderboardOption'" :class="{'leaderboard__header-tab--active': topType === 0}" @click="topType = 0")
          .leaderboard__header-tab(v-t="'season1LeaderboardOptionTrophies'" :class="{'leaderboard__header-tab--active': topType === 1}" @click="topType = 1")
          .leaderboard__header-tab(v-t="'season1LeaderboardOptionRating'" :class="{'leaderboard__header-tab--active': topType === 2}" @click="topType = 2")

      .leaderboard__ad
        .leaderboard__ad-el(v-for="el in els" :key="el.id")
         img.leaderboard__ad-el-img(:alt="el.id" :src="el.img")
         div
           p.leaderboard__ad-el-text(v-html="$t(el.text)")
           Button.leaderboard__ad-el-btn(is-primary v-if="el.isBtn" @click="openStore") {{ $t('buy') }}

      ProfileTabs(v-if="topType > 0" :items="topType === 2 ? tabs.filter(tab => tab.id !== '' && tab.id !== 'lichess') : tabs" :active-tab-index="currentTabIndex" @change="onTabChange")

      .leaderboard__subtitle {{ $t('results') }}

      .leaderboard__info-line
        .leaderboard__comment {{ $t('totalPlayers') }}: {{ totalPlayers }}
        .leaderboard__comment-separator
        .leaderboard__comment {{ $t('winnersAmount') }}: {{ winnersAmount }}
        .leaderboard__comment-separator
        .leaderboard__comment {{ $t('prizePool') }}: {{ prizePool }} G-Cash
        .leaderboard__comment-separator(v-if="topType === 0")
        .leaderboard__comment(v-if="topType === 0") {{ $t('startDate') }}: {{ startDate }}
        .leaderboard__comment-separator(v-if="topType === 0")
        .leaderboard__comment(v-if="topType === 0") {{ $t('endDate') }}: {{ endDate }}

      .leaderboard__date(v-if="dateText") {{ $t('leaderboardLastUpdate') }} {{ dateText }}

      .leaderboard__view-all-container(v-if="listOpened")
        Button.leaderboard__view-all(is-primary @click="listOpened = false") {{ $t('minimise') }}

      .leaderboard__table
        .leaderboard__table-row.leaderboard__table-heading
          .leaderboard__table-heading-item(v-t="'place'")
          .leaderboard__table-heading-item(v-t="'player'")
          .leaderboard__table-heading-item(v-if="topType < 2")
            InlineSvg.leaderboard__table-heading-item-icon(
              :src="require('~/assets/img/icons/trophy.svg')"
            )
            .leaderboard__table-heading-item--desktop {{ $t("points") }}
          .leaderboard__table-heading-item(v-else) {{ $t("rating") }}
          .leaderboard__table-heading-item(v-if="topType === 0" v-t="'totalEarningsPrize'")
          //template(v-for="field in currentTopTypeTab.fields")
          //  template(v-if="!field.onlyDesktop || !isTablet")
          //    .leaderboard__table-heading-item(:key="field.title")
          //      span(v-if="!field.tooltip" v-t="field.title")
          //      Tooltip(v-else is-vertical)
          //        span(v-t="field.title")
          //        InlineSvg(:src="require('~/assets/img/icons/info.svg')" width="20" height="20")
          //        template(v-slot:tooltip)
          //          .leaderboard__tooltip(v-html="$t(field.tooltipContent)")

        .leaderboard__table-row(
          v-if="currentList && currentList.length"
          v-for="(item, index) in currentList.slice(0, countOfRows)"
          :key="item.id"
          :class="getRowClass(index)"
        )
          .leaderboard__table-row-item
            .leaderboard__user-place
              InlineSvg(:src="require(`~/assets/img/icons/star.svg`)")
              | {{ index + 1 }}
          .leaderboard__table-row-item.leaderboard__table-row-item--left
            .leaderboard__user
              img.leaderboard__table-heading-item--desktop(v-if="item.avatar" :src="item.avatar", :alt="item.full_name" height="48" width="48" v-lazy-load)
              .leaderboard__user-name(:class="{'--me': user && item.alias === user.alias}")
                a(:href="`/user/${item.alias}`" target="_blank") {{ item.full_name }}

          .leaderboard__table-row-item(v-if="topType < 2")
            | {{ item.count }}
          .leaderboard__table-row-item(v-else)
            | {{ item.rating }}

          .leaderboard__table-row-item(v-if="topType === 0")
            Currency(type="money") {{ getPrize(item) }}

      .leaderboard__view-all-container(v-if="!listOpened")
        Button.leaderboard__view-all(is-primary @click="listOpened = true") {{ $t('viewAll') }}

      .leaderboard__table(v-if="!listOpened && myPlaceIsNotInTop")
        .leaderboard__table-row(:class="'--me'")
          .leaderboard__table-row-item
            .leaderboard__user-place
              InlineSvg(:src="require(`~/assets/img/icons/star.svg`)")
              | {{ myPlace + 1 }}
          .leaderboard__table-row-item.leaderboard__table-row-item--left
            .leaderboard__user
              img(v-if="myRow.avatar" :src="myRow.avatar", :alt="myRow.full_name" height="48" width="48" v-lazy-load)
              .leaderboard__user-name(:class="{'--me': true}")
                a(:href="`/user/id/${myRow.id}`" target="_blank") {{ myRow.full_name }}

          .leaderboard__table-row-item
            | {{ myRow.count }}

          .leaderboard__table-row-item(v-if="topType === 0")
            Currency(type="money") {{ getPrize(myRow) }}
      //Loader(v-else)

    //.leaderboard__me(v-if="user && me && currentList && currentList.length")
    //  .leaderboard__table
    //    .leaderboard__table-row(:class="getRowClass(-1)")
    //      .leaderboard__table-row-item
    //        .leaderboard__user
    //          .leaderboard__user-place
    //            InlineSvg(:src="require(`~/assets/img/icons/star.svg`)")
    //            | {{ place }}
    //          img(v-if="user.avatar" :src="user.avatar", :alt="user.full_name" height="48" width="48" v-lazy-load)
    //          .leaderboard__user-name(class="--me")
    //            a(:href="`/user/id/${user.id}`" target="_blank") {{ user.full_name }}
    //
    //      .leaderboard__table-row-item(v-if="!isTablet") {{ me.count_game }}
    //      .leaderboard__table-row-item(v-if="!isTablet") {{ Math.round(me.win_persentage) || 0 }}%
    //      .leaderboard__table-row-item {{ (Math.round(me.roi) || 0) }}%
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ProfileTabs from '~/components/ProfileTabs/ProfileTabs'
import Tooltip from '~/components/Tooltip/Tooltip'
import BaseSelect from '~/components/BaseSelect/BaseSelect'

export default {
  name: 'Leaderboard',

  components: { BaseSelect, Tooltip, ProfileTabs },

  asyncData ({ $cookiz, store, i18n }) {
    const currentTabIndex = parseInt($cookiz.get('vvv-leaderboard-tab')) || 0
    const hasAccount = (game) => {
      return !!store.getters['user/gameAccount'](game)
    }
    const tabs = [
      {
        title: 'All Games',
        id: ''
      },
      ...Object.entries(store.state.games.gamesByName)
        .filter(([_, game]) => game.event_count)
        .filter(([_, game]) => game.is_enabled)
        .filter(([name, _]) => ['brawl-stars', 'free-fire', 'clash-royale', 'lichess', 'fortnite', 'pubg-mobile'].includes(name))
        .map(([gameName, game]) => {
          return {
            title: game.extra_data.title,
            id: gameName,
            icon: game.extra_data.icon
          }
        })
        .sort(({ id }, { id: id2 }) => hasAccount(id2) - hasAccount(id))
    ]

    const typeTabs = [
      [
        {
          title: i18n.t('leaderboardTypeROI'),
          id: 'weekly_leaderboard',
          event: true,
          icon: 'https://cdn.gaming-goods.com/images/other/leaderboard/roi.png',
          fields: [
            {
              title: 'leadersPlayed',
              valueKey: 'count_game',
              onlyDesktop: true
            },
            {
              title: 'manyWins',
              round: true,
              percentage: true,
              valueKey: 'win_persentage',
              onlyDesktop: true
            },
            {
              title: 'ROI',
              valueKey: 'roi',
              round: true,
              percentage: true,
              tooltipContent: 'roiDescription'
            }
          ]
        }
      ],
      [
        {
          title: i18n.t('leaderboardTypeROI'),
          id: 'season-trophy',
          icon: 'https://cdn.gaming-goods.com/images/other/leaderboard/roi.png',
          fields: [
            {
              title: 'leadersPlayed',
              valueKey: 'count_game',
              onlyDesktop: true
            },
            {
              title: 'manyWins',
              round: true,
              percentage: true,
              valueKey: 'win_persentage',
              onlyDesktop: true
            },
            {
              title: 'ROI',
              valueKey: 'roi',
              round: true,
              percentage: true,
              tooltipContent: 'roiDescription'
            }
          ]
        }
      ],
      [
        {
          title: i18n.t('leaderboardTypeROI'),
          id: 'game_rating',
          icon: 'https://cdn.gaming-goods.com/images/other/leaderboard/roi.png',
          event: true,
          fields: [
            {
              title: 'leadersPlayed',
              valueKey: 'count_game',
              onlyDesktop: true
            },
            {
              title: 'manyWins',
              round: true,
              percentage: true,
              valueKey: 'win_persentage',
              onlyDesktop: true
            },
            {
              title: 'ROI',
              valueKey: 'roi',
              round: true,
              percentage: true,
              tooltipContent: 'roiDescription'
            }
          ]
        }
      ]
    ]

    const currentTypeTabIndex = 0

    const lists = tabs.reduce((result, tab) => {
      result[tab.id] = {
        list: [],
        me: null
      }
      return result
    }, {})

    const list = []

    const topType = 0
    const selectTopVariants = [
      {
        value: 'leaders',
        title: 'topOfLeaders'
      },
      {
        value: 'loosers',
        title: 'topOfLoosers'
      }
    ]

    const selectedTopVariant = 'leaders'

    return {
      currentTabIndex,
      tabs,
      typeTabs,
      currentTypeTabIndex,
      lists,
      date: null,
      topType,
      selectTopVariants,
      selectedTopVariant,
      list,
      endsAt: undefined
    }
  },

  data () {
    return {
      listOpened: false,
      totalPlayers: '> 200',
      startDate: '20.11.2023, 03:00 (GMT+3)',
      endDate: '27.11.2023, 02:59 (GMT+3)'
    }
  },

  computed: {
    ...mapState('games', ['gamesByName']),
    ...mapState('user', ['user']),
    ...mapGetters('user', ['gameAccount']),
    ...mapGetters('viewport', ['isTablet']),

    els () {
      if (this.topType < 2) {
        return [
          {
            id: 'leaderboardEl1',
            text: 'leaderboardAdEl1Text',
            img: 'https://cdn.gaming-goods.com/images/leaderboard/el1.png',
            isBtn: true
          },
          {
            id: 'leaderboardEl2',
            text: 'leaderboardAdEl2Text',
            img: 'https://cdn.gaming-goods.com/images/leaderboard/el5.png'
          },
          {
            id: 'leaderboardEl3',
            text: 'leaderboardAdEl3Text',
            img: 'https://cdn.gaming-goods.com/images/leaderboard/el6.png'
          },
          {
            id: 'leaderboardEl4',
            text: 'leaderboardAdEl4Text',
            img: 'https://cdn.gaming-goods.com/images/leaderboard/el7.png'
          }
        ]
      }
      return [
        {
          id: 'leaderboardEl1Rating',
          text: 'leaderboardAdEl1RatingText',
          img: 'https://cdn.gaming-goods.com/images/leaderboard/el1.png'
        },
        {
          id: 'leaderboardEl2Rating',
          text: 'leaderboardAdEl2RatingText',
          img: 'https://cdn.gaming-goods.com/images/leaderboard/el2.png'
        },
        {
          id: 'leaderboardEl3Rating',
          text: 'leaderboardAdEl3RatingText',
          img: 'https://cdn.gaming-goods.com/images/leaderboard/el3.png'
        },
        {
          id: 'leaderboardEl4Rating',
          text: 'leaderboardAdEl4RatingText',
          img: 'https://cdn.gaming-goods.com/images/leaderboard/el4.png'
        }
      ]
    },

    countOfRows () {
      return this.listOpened ? 1000 : 10
    },

    myPlaceIsNotInTop () {
      if (!this.user) {
        return false
      }

      return this.list.find((u, index) => u.alias === this.user.alias && index > 9)
    },

    myPlace () {
      if (!this.user) {
        return false
      }

      return this.list.map((u, index) => ({ ...u, index })).find(u => u.alias === this.user.alias)?.index
    },

    myRow () {
      if (!this.user) {
        return false
      }

      return this.list.map((u, index) => ({ ...u, index })).find(u => u.alias === this.user.alias)
    },

    winnersAmount () {
      return this.list?.length || '...'
    },

    prizePool () {
      return ((this.list?.map(element => element.prize).reduce((a, b) => a + b, 0) || 0) / 100).toFixed(2).replace('.00', '')
    },

    dateText () {
      if (!this.date) {
        return null
      }

      const date = this.date?.replace(' ', 'T') + 'Z'

      return this.$dateFns.formatDistanceToNow(this.$dateFns.parseISO(date), {
        includeSeconds: true,
        addSuffix: true,
        locale: this.$i18n.locale
      })
    },

    place () {
      if (this.me) {
        return (
          this.currentList?.findIndex(({ id }) => this.user?.id === id) + 1 ||
          '?'
        )
      }

      return '?'
    },

    currentTab () {
      if (this.topType === 2) {
        return this.tabs.filter(tab => tab.id !== '' && tab.id !== 'lichess')[this.currentTabIndex || 0]
      }
      return this.tabs[this.currentTabIndex || 0]
    },

    currentTopTypeTab () {
      return this.typeTabs?.[this.selectedTopVariant === 'leaders' ? this.topType : 2]?.[this.currentTypeTabIndex || 0]
    },

    currentTopType () {
      return this.currentTopTypeTab?.id
    },

    currentTopIsEvents () {
      return this.currentTopTypeTab?.event
    },

    currentList () {
      return this.list
      // const currentTabId = this.topType === 0 ? this.currentTab.id : 'general'
      // console.log(currentTabId, this.lists.general, this.lists)
      // return this.lists[currentTabId]?.list || []
    },

    me () {
      return this.lists[this.currentTab.id]?.me || null
    },

    isSomeOpened () {
      return false
    }
  },

  watch: {
    currentTab () {
      // if (!this.currentList?.length) {
      this.loadList()
      // }
    },

    currentTypeTabIndex () {
      this.loadList()
    },

    topType () {
      this.onTabChange({ index: 2 })
      this.loadList()
    },

    selectedTopVariant () {
      this.currentTypeTabIndex = 0
      this.loadList()
    }
  },

  mounted () {
    this.loadList()
  },

  methods: {
    async loadList () {
      this.list = []
      this.$nuxt.$loading.start()
      // this.list = [
      //   // {
      //   //   id: 2291,
      //   //   avatar: '',
      //   //   full_name: 'Alex',
      //   //   count: 127,
      //   //   prize: 443
      //   // }
      // ]

      const currentGame = this.currentTab.id

      const requests = []

      if (this.topType > 1 && currentGame !== '') {
        requests.push(this.$axios.get(`/leaderboard/game_rating/${currentGame}?offset=0&limit=100`))
      } else if (this.topType > 0 && currentGame !== '') {
        requests.push(this.$axios.get(`/leaderboard/season_trophy/${currentGame}?offset=0&limit=100`))
      } else {
        const currentTop = this.currentTopIsEvents ? `events/${this.currentTopType}/active` : this.currentTopType
        requests.push(this.$axios.get(`/leaderboard/${currentTop}?offset=0&limit=1000`))
      }

      try {
        const [{ data }] = await Promise.all(requests)

        this.list = data.data.extra_data?.result || (data.data.users.map((user, index) => ({ ...user }))) // , prize: data.data.prizes?.places?.[index]
        if (this.currentTopIsEvents) {
          // this.prizePool = data.data.prize_pool
          this.endsAt = data.data.ends_at
          this.totalPlayers = data.data.totalUsers
        }

        this.date = data.data.updated_at
        this.$forceUpdate()
      } catch (e) {
        console.error('ssr leaderboard err', currentGame, e)
        this.$errors.handle(e)
      }

      this.$nuxt.$loading.finish()
    },

    getPrize (item) {
      console.log(item)
      return (item.prize / 100).toFixed(2).replace('.00', '')
    },

    onTabChange ({ index }) {
      this.currentTabIndex = index
      this.$cookiz.set('vvv-leaderboard-tab', index)
    },

    onTypeTabChange ({ index }) {
      this.currentTypeTabIndex = index
    },

    openStore () {
      this.$gtag.event('click_leaderboard_page_button_subscriptions_store', {})
      this.$router.push(this.localeLocation('/store/subscriptions'))
    },

    formatFunction (field, value) {
      let result = value || 0
      if (field.devide100) {
        result = Number(result) / 100
      }
      if (field.round) {
        result = result.toFixed(0)
      }
      if (field.percentage) {
        result += ' %'
      }
      if (field.moneyIcon) {
        result += ' G-Cash'
      }
      return result
    },

    getRowClass (index) {
      if (index === -1) {
        return {
          '--gold': this.user?.id === this.currentList?.[0]?.id,
          '--silver': this.user?.id === this.currentList?.[1]?.id,
          '--bronze': this.user?.id === this.currentList?.[2]?.id,
          '--me': this.user?.alias === this.currentList?.[2]?.alias
        }
      }

      return {
        '--gold': index === 0,
        '--silver': index === 1,
        '--bronze': index === 2,
        '--me': this.currentList[index].alias === this.user?.alias
      }
    }
  }
}
</script>

<style lang="scss">
.leaderboard {
  color: #fff;
  position: relative;

  .page__content {
    margin: 40px auto 0;
  }

  &__ad {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
    margin: 25px 0;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
      grid-gap: 12px;
    }

    @media (min-width: $breakpointDesktopWide) {
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 24px;
    }

    &-el {
      display: grid;
      grid-template-columns: 56px 1fr;
      grid-gap: 16px;
      align-items: center;
      padding: 12px 20px;
      border-radius: 16px;
      background: rgba($primary60, 0.2);

      @media (min-width: $breakpointDesktopWide) {
        grid-template-columns: 1fr;
        grid-template-rows: 60px max-content;
        padding: 20px 28px;
      }

      &-text {
        color: $white;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;

        @media (min-width: $breakpointDesktopWide) {
          text-align: center;
        }
      }

      &-img {
        width: 100%;
        max-height: 100%;
        object-fit: contain;
        max-width: 160px;
        margin: auto;
      }

      &-btn {
        margin-top: 12px;
        width: 100% !important;
      }
    }
  }

  &__info-line {
    @media (min-width: $breakpointDesktopWide) {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }

  &__header {
    margin-bottom: 40px;

    @media (min-width: $breakpointTablet) {
      display: grid;
      grid-template-columns: repeat(2, max-content);
      grid-gap: 24px;
      align-items: baseline;
    }

    @media (min-width: $breakpointDesktop) {
      grid-template-columns: max-content max-content 1fr;
    }

    h1 {
      font-style: normal;
      font-weight: 700;
      font-size: 40px;
      line-height: 48px;
      margin-bottom: 16px;

      @media (min-width: $breakpointTablet) {
        margin-bottom: 0;
      }
    }

    &-tabs {
      display: grid;
      grid-template-columns: repeat(3, max-content);
      grid-gap: 12px;
      overflow-x: auto;
    }

    &-tab {
      padding: 8px 16px;
      border-radius: 100px;
      background: rgba($white, 0.1);
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: $white;
      text-align: center;
      cursor: pointer;

      &--active {
        background: linear-gradient(90deg, #1E88E5 0%, #42A5F5 100%);
      }
    }

    &-offerwalls {
      display: none;

      @media (min-width: $breakpointDesktop) {
        display: grid;
        grid-template-columns: max-content max-content;
        grid-gap: 24px;
        width: 100%;
        align-items: baseline;
        justify-content: flex-end;
      }

      &-button {
        color: $white;
      }

      &-text {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: $blue-grey05;
        margin-bottom: 8px;
      }
    }
  }

  &__view-all {
    width: 100%;

    @media (min-width: $breakpointTablet) {
      width: auto;
    }

    &-container {
      margin: 24px 0 8px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  &__comment {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: $blue-grey05;
    margin-bottom: 4px;

    @media (min-width: $breakpointDesktopWide) {
      margin-bottom: 0;
    }

    &-timer {
      margin-left: 4px;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: $white;
    }

    &-separator {
      display: none;

      @media (min-width: $breakpointDesktopWide) {
        display: block;
        height: 4px;
        width: 4px;
        background: $primary50;
        border-radius: 50%;
        margin: 0 10px;
      }
    }
  }

  &__prize-of-the-week {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 16px;
  }

  &__baking-button {
    padding-left: 24px;
  }

  &__show-top {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 24px;

    @media (min-width: $breakpointTablet) {
      flex-direction: row;
      margin-bottom: 42px;
      align-items: center;
    }

    &-text {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 120%;
      margin-bottom: 8px;

      @media (min-width: $breakpointTablet) {
        margin-right: 18px;
        margin-bottom: 0;
      }
    }

    &-select {
      max-width: 296px;
      margin-bottom: 20px;

      @media (min-width: $breakpointTablet) {
        margin-right: 32px;
        margin-bottom: 0;
      }
    }

    &-label {
      display: none;

      @media (min-width: $breakpointTablet) {
        display: inline;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        max-width: 285px;
      }
    }
  }

  .profile-tabs {
    margin-bottom: 32px;
  }

  &__subtitle {
    @include heading2;

    margin-bottom: 12px;
  }

  &__date {
    margin: 12px 0 28px;
    padding-top: 12px;
    color: $blue-grey10;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    border-top: 1px solid $blue-grey40;
  }

  &__tooltip {
    @include hint-small;

    max-width: 400px;
    color: #fff;

    & > strong {
      @include heading6;

      display: block;
      padding-bottom: 8px;
    }

    p {
      margin: 8px 0;
    }
  }

  &__me {
    position: sticky;
    bottom: 0;
    z-index: 2;
    background: $blue-grey70;
    border-top: 1px solid $blue-grey50;
    overflow: hidden;
    height: 72px;
    display: flex;
    align-items: center;
    margin-top: 24px;
    width: 100vw;
    max-width: 100vw;
    margin-left: calc(50% - 50vw);

    @media (max-width: $breakpointDesktopBig) {
      padding: 0 65px;
    }

    @media (max-width: $breakpointTablet) {
      height: 60px;
    }

    @media (max-width: $breakpointHeaderMobile) {
      bottom: 46px;
    }

    .leaderboard__table {
      margin: 0 auto;
      max-width: 1371px;

      &-row {
        background: none;

        &::after {
          background: $blue-grey70 !important;
        }
      }
    }
  }

  &__user {
    display: flex;
    align-items: center;

    img {
      margin-right: 11px;
      border-radius: 16px;
      object-fit: cover;
      width: 48px;
      height: 48px;
      overflow: hidden;

      @media (max-width: $breakpointTablet) {
        width: 40px;
        height: 40px;
        border-radius: 8px;
      }
    }

    &-place {
      @include hint;

      height: 48px;
      width: 87px;
      margin-right: 16px;
      border-right: 1px solid $blue-grey30;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        margin-right: 6px;
        margin-top: -2px;
      }
    }

    &-name {
      @include hint;

      font-size: 20px;

      &.--me a {
        color: $cyan50;
      }
    }
  }

  &__table {
    width: 100%;
    margin-top: 26px;

    &-row {
      background: $blue-grey60;
      position: relative;
      overflow: hidden;
      display: grid;
      grid-template-columns: 20% 1fr 15% 15%;
      align-items: center;
      border-radius: 8px;
      margin-bottom: 8px;
      width: 100%;

      @media (min-width: $breakpointTablet) {
        grid-template-columns: 20% 1fr 15% 15%;
      }

      &.--me {
        background: $blue-grey50;
        border: 1px solid $cyan40;
        color: $cyan40;
      }

      &::after {
        border-radius: 8px;
        position: absolute;
        top: 2px;
        left: 2px;
        right: 2px;
        bottom: 2px;
        background: $blue-grey60;
        z-index: 0;
        overflow: hidden;
      }

      &.--gold {
        .leaderboard__user {
          &-place {
            svg path {
              fill: $amber50;
            }
          }
        }

        &::after {
          content: "";
        }

        background:
          linear-gradient(173deg, $amber50 8%, rgba($amber50, 0) 25%),
          linear-gradient(-6deg, $amber50 8%, rgba($amber50, 0) 25%);

        .leaderboard__table-row-item:last-child {
          color: $amber50;
        }
      }

      &.--silver {
        .leaderboard__user {
          &-place {
            svg path {
              fill: $grey05;
            }
          }
        }

        &::after {
          content: "";
        }

        background:
          linear-gradient(173deg, $grey05 8%, rgba($grey05, 0) 25%),
          linear-gradient(-6deg, $grey05 8%, rgba($grey05, 0) 25%);

        .leaderboard__table-row-item:last-child {
          color: $grey05;
        }
      }

      &.--bronze {
        .leaderboard__user {
          &-place {
            svg path {
              fill: $orange90;
            }
          }
        }

        &::after {
          content: "";
        }

        background:
          linear-gradient(
            173deg,
            $orange90 8%,
            rgba($orange90, 0) 25%
          ),
          linear-gradient(-6deg, $orange90 8%, rgba($orange90, 0) 25%);

        .leaderboard__table-row-item:last-child {
          color: $orange90;
        }
      }

      &-item {
        @include hint;

        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 2;
        flex: 1;

        &:first-child {
          border-radius: 8px 0 0 8px;
          justify-content: flex-start;
          flex: 3;
        }

        &:last-child {
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          border-radius: 0 8px 8px 0;
          padding-right: 46px;
        }

        &--left {
          justify-content: flex-start;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &-heading {
      display: grid;
      grid-template-columns: 20% 1fr 15% 15%;
      grid-gap: 10px;
      background: $blue-grey70;
      position: sticky;
      top: 48px;
      z-index: 3;

      @media (min-width: $breakpointTablet) {
        grid-template-columns: 20% 1fr 15% 15%;
      }

      &-item {
        @include hint-small;

        height: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: $blue-grey05;
        flex: 1;

        &--desktop {
          display: none;

          @media (min-width: $breakpointTablet) {
            display: flex;
          }
        }

        &:first-child {
          border-radius: 8px 0 0 8px;
          flex: 3;
        }

        &:last-child {
          border-radius: 0 8px 8px 0;
          padding-right: 46px;
        }

        &-icon {
          width: 16px;
          height: 16px;

          path {
            fill: $amber60 !important;
          }
        }

        svg {
          margin-left: 8px;

          path,
          rect {
            fill: $blue-grey05;
          }
        }

        .tooltip {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  @media (max-width: $breakpointTablet) {
    &__table {
      border-spacing: 0 4px;

      &-row {
        &-item {
          height: 56px;

          &:last-child {
            @include info-small;

            padding-right: 16px;
          }
        }
      }

      &-heading-item:last-child {
        padding-right: 16px;
      }
    }

    &__user {
      &-place {
        @include hint-small;

        height: 32px;
        width: 40px;
        margin-right: 12px;
        border-right: 1px solid $blue-grey30;
        flex-direction: column;

        svg {
          margin-right: 0;
          margin-top: 0;
          margin-bottom: 4px;
        }
      }

      &-name {
        @include hint-small;
      }
    }
  }

  &__offerwall-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    width: 100%;
    bottom: 45px;
    left: 0;
    padding: 12px;
    border-top: 1px solid $blue-grey40;
    border-bottom: 1px solid $blue-grey40;
    background-color: $blue-grey80;
    z-index: 2;

    @media (min-width: $breakpointTablet) {
      bottom: 0;
    }

    @media (min-width: $breakpointTablet) {
      display: none;
    }

    &-button {
      color: $white;
    }

    &-text {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: $blue-grey05;
      margin-bottom: 8px;
    }
  }
}
</style>
